
import { Base } from '../base-component';

import './table-popup-checklist.component.scss';

import { MediaQueryService } from '../../services/media-query.service';

import * as $ from 'jquery';

export class TablePopupChecklist extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	tableHeader: HTMLElement;
	tableRows: HTMLElement[];

	constructor(element: Element){
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		this.modals = Array.from(this.element.querySelectorAll('.js-table-popup-checklist-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-table-popup-checklist-modal-open'));
		this.closeButton = this.element.querySelector('.js-table-popup-checklist-modal-close');

		this.tableHeader = this.element.querySelector('.js-table-header') as HTMLElement;
		this.tableRows = Array.from(this.element.querySelectorAll('.js-table-row')) as HTMLElement[];

		setTimeout(() => {
			this.equalHeights();
		}, 100);

	}

	bindEvents() {

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
        }));

		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('orientationchange', this.onResize.bind(this));

	}

	onResize() {

		setTimeout(() => {
			this.equalHeights();
		}, 100);

	}

	equalHeights() {

		this.defaultHeights();

		if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {

			let tallestHeader = this.getTallestColumnInRow(this.tableHeader, 'th');
			this.tableHeader.style.height = `${tallestHeader}px`;

			for (let i = 0; i < this.tableRows.length; i++) {

				let tallestColumn = this.getTallestColumnInRow(this.tableRows[i], 'td');
				this.tableRows[i].style.height = `${tallestColumn}px`;

			}

		}

	}

	getTallestColumnInRow(row, type) {

		let columns = row.querySelectorAll(type) as HTMLElement[];
		let tallestColumn = 60;

		for (let i = 0; i < columns.length; i++) {

			let el = columns[i];
			let elHeight = el.offsetHeight;

			if (elHeight > tallestColumn) {
				tallestColumn = elHeight;
			}

		}

		return tallestColumn;

	}

	defaultHeights() {

		this.tableHeader.style.height = '';

		for (let i = 0; i < this.tableRows.length; i++) {
			this.tableRows[i].style.height = '';
		}

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {
		
		let element: Element = event.target;
		let modalId = element.getAttribute('data-modal');

		if(!modalId){
			let  parentElement = $(element).closest('.js-table-popup-checklist-modal-open');
			modalId = parentElement.attr('data-modal');
		}

		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	closeModal() {

		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModal() {

		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');

		this.equalHeights();

	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

}



// WEBPACK FOOTER //
// ./components/table-popup-checklist/table-popup-checklist.component.ts